module.exports = __webpack_public_path__ + "img/chris (77).03766ee7.jpg";